import styles from "./FlixMedia.module.scss";
import LoadingSpinner from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import Plus24PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Plus24PxOutlined";
import Minus24PxOutlined from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Minus24PxOutlined";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  /**
   * A boolean indicating whether the component is loading.
   */
  isLoading: boolean;
  /**
   * A boolean indicating whether the component is open.
   */
  isOpen: boolean;
  /**
   * A function that handles the toggle event.
   */
  handleToggle: () => void;
  /**
   * A reference to the FlixMedia container div element.
   */
  flixMediaContainerRef: React.RefObject<HTMLDivElement>;
  /**
   * A reference to the FlixMedia inpage div element.
   */
  flixMediaInpageRef: React.RefObject<HTMLDivElement>;
  /**
   * The properties of the div element.
   */
  props: React.ComponentPropsWithoutRef<"div">;
};

export const FlixMediaUI = ({
  isLoading,
  isOpen,
  handleToggle,
  flixMediaContainerRef,
  flixMediaInpageRef,
  props,
}: Props) => {
  const Minus24PxOutlinedInverted = () => (
    <Minus24PxOutlined className={styles.toggleIcon} />
  );

  const Plus24PxOutlinedIconInverted = () => (
    <Plus24PxOutlinedIcon className={styles.toggleIcon} />
  );

  return (
    <div
      ref={flixMediaContainerRef}
      className={styles.wrapper}
      {...props}
      data-testid="flix-media-wrapper"
    >
      {isLoading && (
        <LoadingSpinner data-testid="flix-media-loading-spinner" centered />
      )}
      <div
        data-testid="flix-media-inpage-container"
        className={cx(styles.inpageContainer, {
          revealed: isOpen,
          hidden: isLoading,
        })}
      >
        <div className={styles.header}>
          <h2 className={styles.title}>Take a closer look</h2>
          Information from the brand
        </div>

        <div id="flix-react-inpage" ref={flixMediaInpageRef} />
      </div>
      <div
        className={cx(styles.footer, {
          hidden: isLoading,
          revealedFooter: isOpen,
        })}
        data-testid="flix-media-footer"
      >
        <TertiaryButton
          className={styles.toggleButton}
          data-testid="flix-media-footer-button"
          onClick={handleToggle}
          small={true}
          variant="filled-dark"
          IconComponent={
            isOpen ? Minus24PxOutlinedInverted : Plus24PxOutlinedIconInverted
          }
          iconPositionRight
        >
          <span className={styles.toggleText}>
            {isOpen ? "Show less" : "Show more"}
          </span>
        </TertiaryButton>
      </div>
    </div>
  );
};
